import { ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import { RootState } from 'store/store';
import {
  item_delete as deleteItem,
  item_createNewDocument as createDocument,
  item_deleteFn,
  item_createNewDocumentFn,
} from 'store/providers/providerSlice';
import { deleteItem as deleteItemAction } from 'store/providers/providerSlice';
import Document, * as DocumentExport from 'store/entity/Document';

import messages from './Messages';
import Button from 'components/Button';
import notify from 'components/Notify';
import { display } from 'components/ErrorView/ErrorDialog';
import ProfilePicture from 'containers/Profile/Panels/ProfilePicture/ProfilePicture';
import { IProvider, IProviderItemView } from 'store/providers/providerTypes';
import ProviderDocument from 'store/providers/providerUtils';

const JSProfilePicture: any = ProfilePicture;

interface IStateToProps {
  thisProvider: IProvider;
}

interface IDispatchToProps {
  deleteItem: ({
    item,
  }: {
    item: IProviderItemView;
  }) => ReturnType<typeof item_deleteFn>;
  createDocument: ({
    item,
    file,
    setProgress,
  }: {
    item: IProviderItemView;
    file: any;
    setProgress?: (p: number) => void;
  }) => ReturnType<typeof item_createNewDocumentFn>;
  deleteItemAction: ({ item }: { item: IProviderItemView }) => void;
}

interface IOwnProps {
  providerId?: number;
  hasGeneralAccess?: boolean;
}

type IComponentProps = IOwnProps &
  IStateToProps &
  IDispatchToProps &
  RouteComponentProps;

interface IComponentStates {
  saving: boolean;
}

class Pictures extends React.Component<IComponentProps, IComponentStates> {
  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      saving: false,
    };
  }

  pictures: any = {
    background: undefined,
    profilePicture: undefined,
    verticalBackground: undefined,
    horizontalBackground: undefined,
  };

  handleChangeBackground = (item: any, data: any) => {
    let jsItem;
    if (item) {
      jsItem = item;
    }
    this.pictures.background = { item: jsItem, data };
  };

  handleChangeProfilePicture = (item: any, data: any) => {
    let jsItem;
    if (item) {
      jsItem = item;
    }
    this.pictures.profilePicture = { item: jsItem, data };
  };

  handleChangeVerticalBackground = (item: any, data: any) => {
    let jsItem;
    if (item) {
      jsItem = item;
    }
    this.pictures.verticalBackground = { item: jsItem, data };
  };

  handleChangeHorizontalBackground = (item: any, data: any) => {
    let jsItem;
    if (item) {
      jsItem = item;
    }
    this.pictures.horizontalBackground = { item: jsItem, data };
  };

  uploadDocuments = async () => {
    this.setState({ saving: true });
    const { thisProvider } = this.props;
    const provider = thisProvider;
    const promises = [];

    if (this.pictures.profilePicture) {
      if (this.pictures.profilePicture.data === null) {
        promises.push(this.props.deleteItem(this.pictures.profilePicture));
      } else {
        const documentProperties = { photo: true };
        const document = new Document(
          null,
          DocumentExport.documentType.profilePicture,
          documentProperties as any
        );
        const providerDocument: any = new ProviderDocument(
          provider?.id,
          undefined,
          null,
          null,
          document,
          true,
          0
        );
        const updateProfile = this.props
          .createDocument({
            item: providerDocument,
            file: this.pictures.profilePicture.data,
          })
          .then(() => {
            if (this.pictures.profilePicture.item) {
              promises.push(
                this.props.deleteItem(this.pictures.profilePicture)
              );
              this.props.deleteItemAction({
                item: this.pictures.profilePicture.item,
              });
            }
            this.pictures.profilePicture = undefined;
            notify(messages.profilePictureSuccessfullySaved);
            if (this.pictures.background === undefined) {
              this.setState({ saving: false });
            }
          })
          .catch((err: any) => {
            display(err);
          });
        promises.push(updateProfile);
      }
    }
    if (this.pictures.background) {
      if (this.pictures.background.data === null) {
        promises.push(this.props.deleteItem(this.pictures.background));
      } else {
        const documentProperties = { photo: true };
        const document = new Document(
          null,
          DocumentExport.documentType.banner,
          documentProperties as any
        );
        const providerDocument: any = new ProviderDocument(
          provider?.id,
          undefined,
          null,
          null,
          document,
          true,
          0
        );
        const updateBackGround = this.props
          .createDocument({
            item: providerDocument,
            file: this.pictures.background.data,
          })
          .then(() => {
            if (this.pictures.background.item) {
              promises.push(this.props.deleteItem(this.pictures.background));
              this.props.deleteItemAction({
                item: this.pictures.background.item,
              });
            }
            this.pictures.background = undefined;
            notify(messages.bannerSuccessfullySaved);
            if (this.pictures.profilePicture === undefined) {
              this.setState({ saving: false });
            }
          })
          .catch((err: any) => {
            display(err);
          });
        promises.push(updateBackGround);
      }
    }
    if (this.pictures.verticalBackground) {
      if (this.pictures.verticalBackground.data === null) {
        promises.push(this.props.deleteItem(this.pictures.verticalBackground));
      } else {
        const documentProperties = { photo: true };
        const document = new Document(
          null,
          DocumentExport.documentType.carouselVertical,
          documentProperties as any
        );
        const providerDocument: any = new ProviderDocument(
          provider?.id,
          undefined,
          null,
          null,
          document,
          true,
          0
        );
        const updateBackGround = this.props
          .createDocument({
            item: providerDocument,
            file: this.pictures.verticalBackground.data,
          })
          .then(() => {
            if (this.pictures.verticalBackground.item) {
              promises.push(
                this.props.deleteItem(this.pictures.verticalBackground)
              );
              this.props.deleteItemAction({
                item: this.pictures.verticalBackground.item,
              });
            }
            this.pictures.verticalBackground = undefined;
            notify(messages.verticalBackgroundSuccessfullySaved);
            if (this.pictures.profilePicture === undefined) {
              this.setState({ saving: false });
            }
          })
          .catch((err: any) => {
            display(err);
          });
        promises.push(updateBackGround);
      }
    }
    if (this.pictures.horizontalBackground) {
      if (this.pictures.horizontalBackground.data === null) {
        promises.push(
          this.props.deleteItem(this.pictures.horizontalBackground)
        );
      } else {
        const documentProperties = { photo: true };
        const document = new Document(
          null,
          DocumentExport.documentType.carouselHorizontal,
          documentProperties as any
        );
        const providerDocument: any = new ProviderDocument(
          provider?.id,
          undefined,
          null,
          null,
          document,
          true,
          0
        );
        const updateBackGround = this.props
          .createDocument({
            item: providerDocument,
            file: this.pictures.horizontalBackground.data,
          })
          .then(() => {
            if (this.pictures.horizontalBackground.item) {
              promises.push(
                this.props.deleteItem(this.pictures.horizontalBackground)
              );
              this.props.deleteItemAction({
                item: this.pictures.horizontalBackground.item,
              });
            }
            this.pictures.horizontalBackground = undefined;
            notify(messages.horizontalBackgroundSuccessfullySaved);
            if (this.pictures.profilePicture === undefined) {
              this.setState({ saving: false });
            }
          })
          .catch((err: any) => {
            display(err);
          });
        promises.push(updateBackGround);
      }
    }

    Promise.all(promises).then(() => {
      this.setState({ saving: false });
    });
  };

  render() {
    const { thisProvider, hasGeneralAccess } = this.props;
    return (
      <div style={{ overflow: 'auto' }}>
        <Helmet>
          <title>{messages.profilePictures}</title>
          <meta name="description" content={messages.profilePictures} />
        </Helmet>
        <div className="row">
          <div id="pp" className="col s12">
            <JSProfilePicture
              provider={thisProvider}
              className="section"
              changeBackground={this.handleChangeBackground}
              changeProfilePicture={this.handleChangeProfilePicture}
              onChangeVerticalBackground={this.handleChangeVerticalBackground}
              onChangeHorizontalBackground={
                this.handleChangeHorizontalBackground
              }
              hasGeneralAccess={hasGeneralAccess}
            />
            <Button
              color="black"
              style={{ marginTop: '1rem' }}
              loading={this.state.saving}
              onClick={this.uploadDocuments}
            >
              {messages.save}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const providerId = Number(props.providerId);
  const thisProvider = state.providers.map[providerId].data!;
  return {
    thisProvider,
  };
};

const mapDispatchToProps: MapDispatchToProps<IDispatchToProps, IOwnProps> = (
  dispatch: ThunkDispatch<any, never, any>
) => ({
  deleteItem: ({ item }) => dispatch(deleteItem({ item })).unwrap(),
  deleteItemAction: ({ item }) => dispatch(deleteItemAction({ item })),
  createDocument: ({ item, file, setProgress }) =>
    dispatch(createDocument({ item, file, setProgress })).unwrap(),
});

export default connect(mapStateToProps, mapDispatchToProps)(Pictures);
